// extracted by mini-css-extract-plugin
export default {"footerSection":"FooterSection_footerSection__myPLA","buttonContainer":"FooterSection_buttonContainer__lb8ci"};